import { EMPTY_ADHOC_HOLD_OF_CNTR_MODEL } from "presentation/model/AdhocHoldOfContainer/AdhocHoldOfCntrModel";
import { useState } from "react";
import { createContainer } from "react-tracked";

const {
    Provider: AdhocHoldOfCntrProvider,
    useTracked: useAdhocHoldOfCntrTracked
} = createContainer(() => useState(EMPTY_ADHOC_HOLD_OF_CNTR_MODEL), { concurrentMode: true });
export { AdhocHoldOfCntrProvider, useAdhocHoldOfCntrTracked };

